import { useState } from 'react';
import { Link } from 'react-router-dom';
import UtilityBar from '../components/layout/UtilityBar';
import Navbar from '../components/layout/Navbar';
import Footer from '../components/layout/Footer';
import ImageSlot from '../components/ui/ImageSlot';
import LincolnAvatar from '../components/ui/LincolnAvatar';
import Select from '../components/ui/Select';

const TUTORS = [
  { id: 't1', name: 'Hassan Raza',     subject: 'Math · A-levels',    country: '🇵🇰 Pakistan',  rate: '€18/hr', rating: 4.95, sessions: 412, color: '#f0b80c', langs: ['EN', 'UR'],
    photo: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=500&auto=format&fit=crop&q=80' },
  { id: 't2', name: 'Maria Eriksson',  subject: 'Curriculum / AI',    country: '🇫🇮 Finland',   rate: '€42/hr', rating: 4.98, sessions: 286, color: '#2b6cd9', langs: ['FI', 'SV', 'EN'],
    photo: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=500&auto=format&fit=crop&q=80' },
  { id: 't3', name: 'Sofia Lopez',     subject: 'Spanish / English',  country: '🇺🇸 California', rate: '€24/hr', rating: 4.92, sessions: 308, color: '#22b572', langs: ['ES', 'EN'],
    photo: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=500&auto=format&fit=crop&q=80' },
  { id: 't4', name: 'Tomi Vainio',     subject: 'Physics · IB',       country: '🇫🇮 Finland',   rate: '€35/hr', rating: 4.96, sessions: 224, color: '#7a3a8a', langs: ['FI', 'EN'],
    photo: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=500&auto=format&fit=crop&q=80' },
  { id: 't5', name: 'Linnea Karlsson', subject: 'Swedish & Maltese',  country: '🇲🇹 Malta',     rate: '€22/hr', rating: 4.90, sessions: 198, color: '#c97864', langs: ['SV', 'MT', 'EN'],
    photo: 'https://images.unsplash.com/photo-1544005313-94ddf0286df2?w=500&auto=format&fit=crop&q=80' },
  { id: 't6', name: 'Anita Sharma',    subject: 'Biology · NEET',     country: '🇮🇳 India',     rate: '€16/hr', rating: 4.94, sessions: 514, color: '#1e7a6a', langs: ['EN', 'HI'],
    photo: 'https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?w=500&auto=format&fit=crop&q=80' },
  { id: 't7', name: 'Jukka Heikkinen', subject: 'Computer Science',   country: '🇫🇮 Finland',   rate: '€38/hr', rating: 4.97, sessions: 176, color: '#0e1f36', langs: ['FI', 'EN'],
    photo: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=500&auto=format&fit=crop&q=80' },
  { id: 't8', name: 'Erkka Salo',      subject: 'Math · SAT prep',    country: '🇫🇮 Finland',   rate: '€30/hr', rating: 4.93, sessions: 142, color: '#5b3a8a', langs: ['EN', 'FI'],
    photo: 'https://images.unsplash.com/photo-1519085360753-af0119f7cbe7?w=500&auto=format&fit=crop&q=80' },
];

const FILTERS = [
  { title: 'Subject',  opts: ['Math (78)', 'Sciences (54)', 'Languages (62)', 'Test Prep (38)', 'Humanities (21)', 'Vocational (16)'] },
  { title: 'Country',  opts: ['Finland', 'Malta', 'USA', 'Pakistan', 'India', 'Global'] },
  { title: 'Language', opts: ['English', 'Finnish', 'Swedish', 'Maltese', 'Spanish', 'Urdu', 'Hindi'] },
  { title: 'Price',    opts: ['Under €20/hr', '€20–40/hr', '€40+/hr', 'Sliding scale'] },
  { title: 'Verified', opts: ['Lincoln Verified', 'WEF Partner Tutor', 'Background-checked'] },
];

export default function Tutors() {
  const [filtersOpen, setFiltersOpen] = useState(false);
  const [sort, setSort] = useState('Best match');
  return (
    <div className="bg-white">
      <UtilityBar />
      <Navbar />

      {/* Hero */}
      <section className="relative overflow-hidden text-white" style={{ background: 'linear-gradient(160deg, var(--navy) 0%, var(--navy-3) 100%)', padding: '80px 0 60px' }}>
        <div className="absolute pointer-events-none rounded-full"
          style={{ top: -150, right: -100, width: 600, height: 600, background: 'radial-gradient(circle, rgba(240,184,12,0.18), transparent 65%)' }} />

        <div className="lc-container on-navy relative" style={{ zIndex: 1 }}>
          <div className="grid items-center" style={{ gridTemplateColumns: '1.3fr 1fr', gap: 60 }}>
            <div>
              <span className="lc-eyebrow on-dark">Find a tutor</span>
              <h1 className="text-white mt-3.5" style={{ fontSize: 64, letterSpacing: '-0.03em', lineHeight: 1 }}>
                Talk to a <span style={{ color: 'var(--yellow)' }}>real human</span> tutor.<br />
                <span className="italic font-serif font-medium" style={{ color: 'rgba(255,255,255,0.7)' }}>When Lincoln isn&apos;t enough.</span>
              </h1>
              <p className="mt-4 leading-relaxed" style={{ fontSize: 18, color: 'rgba(255,255,255,0.78)', maxWidth: 560 }}>
                Lincoln-vetted tutors in 40+ subjects and 20+ languages. Book live voice sessions, schedule recurring lessons, or chat asynchronously.
              </p>

              {/* Search bar */}
              <div className="bg-white flex items-center gap-2 mt-7"
                style={{ borderRadius: 14, padding: 8, maxWidth: 620, boxShadow: 'var(--shadow-lg)', minWidth: 0 }}>
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="var(--muted)" strokeWidth="2.4" style={{ marginLeft: 10, flexShrink: 0 }}>
                  <circle cx="11" cy="11" r="8" /><path d="m21 21-4.35-4.35" />
                </svg>
                <input
                  placeholder="What do you want help with?"
                  className="flex-1 outline-none"
                  style={{ border: 0, fontSize: 15, padding: '10px 0', color: 'var(--ink)', fontFamily: 'inherit', minWidth: 0, width: '100%' }}
                />
                <button type="button" className="lc-btn primary sm flex-shrink-0">Search</button>
              </div>

              <div className="flex flex-wrap items-center gap-x-7 gap-y-3 mt-7">
                {[
                  { v: '10+', l: 'Verified tutors' },
                  { v: '7',   l: 'Subjects' },
                  { v: '3',   l: 'Languages' },
                  { v: '4.94', l: 'Avg. rating' },
                ].map((s) => (
                  <div key={s.l} className="flex items-baseline gap-1.5">
                    <span className="font-serif font-semibold" style={{ fontSize: 28, color: 'var(--yellow)' }}>{s.v}</span>
                    <span style={{ fontSize: 13, color: 'rgba(255,255,255,0.65)' }}>{s.l}</span>
                  </div>
                ))}
              </div>
            </div>

            <div className="relative flex justify-center overflow-hidden" style={{ width: '100%', borderRadius: 20 }}>
              <ImageSlot
                id="tutors-hero"
                style={{ width: '100%', maxWidth: 380, height: 380 }}
                shape="rounded"
                radius="20"
                src="https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?w=900&auto=format&fit=crop&q=80"
                placeholder="Drop a hero photo — tutor at work, headphones on"
              />
              <div className="hidden md:block absolute" style={{ bottom: 16, right: 16 }}>
                <LincolnAvatar size={110} pulse withMicChip={false} />
              </div>
              {/* Floating chip — desktop only */}
              <div className="hidden md:block absolute bg-white"
                style={{ top: 20, left: 16, padding: '10px 14px', borderRadius: 12, boxShadow: 'var(--shadow-md)', fontSize: 12, fontWeight: 600, color: 'var(--ink)', transform: 'rotate(-4deg)' }}>
                <div style={{ fontSize: 10, color: 'var(--muted)', letterSpacing: '0.08em' }}>NEXT SESSION</div>
                <div className="mt-0.5">📞 Today, 17:00 · Maria</div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Listings */}
      <section className="lc-section">
        <div className="lc-container">
          <div className="lc-tutors-grid grid" style={{ gridTemplateColumns: '260px 1fr', gap: 40 }}>
            <aside className="lc-tutors-filters self-start md:sticky" style={{ top: 90 }}>
              {/* Mobile-only toggle */}
              <button
                type="button"
                onClick={() => setFiltersOpen((v) => !v)}
                className="lc-filters-toggle md:hidden w-full flex items-center justify-between font-bold"
                style={{ padding: '12px 16px', borderRadius: 10, border: '1px solid var(--line)', background: 'var(--bg-soft)', fontSize: 14, color: 'var(--ink)', marginBottom: 12 }}
                aria-expanded={filtersOpen}
              >
                <span className="inline-flex items-center gap-2">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4"><path d="M3 6h18M6 12h12M10 18h4" /></svg>
                  Filters
                </span>
                <span style={{ fontSize: 12 }}>{filtersOpen ? '▲' : '▼'}</span>
              </button>

              <div className={`lc-filters-body ${filtersOpen ? 'block' : 'hidden'} md:block`}>
                {FILTERS.map((g) => (
                  <div key={g.title} className="mb-6 pb-6" style={{ borderBottom: '1px solid var(--line)' }}>
                    <div className="font-bold mb-2.5" style={{ fontSize: 13, color: 'var(--ink)' }}>{g.title}</div>
                    <div className="flex flex-col gap-2">
                      {g.opts.map((o) => (
                        <label key={o} className="flex items-center gap-2 cursor-pointer" style={{ fontSize: 13, color: 'var(--ink-2)' }}>
                          <input type="checkbox" style={{ accentColor: 'var(--green)' }} /> {o}
                        </label>
                      ))}
                    </div>
                  </div>
                ))}
                <button type="button" className="lc-btn primary w-full">Apply filters</button>
              </div>
            </aside>

            <div>
              <div className="lc-tutors-header flex justify-between items-center mb-6 flex-wrap gap-3">
                <div style={{ fontSize: 14, color: 'var(--muted)' }}>
                  Showing <strong style={{ color: 'var(--ink)' }}>1–8</strong> of <strong style={{ color: 'var(--ink)' }}>480 tutors</strong>
                </div>
                <div className="lc-sort-row flex items-center gap-2" style={{ fontSize: 13 }}>
                  <span style={{ color: 'var(--muted)' }}>Sort by:</span>
                  <Select
                    value={sort}
                    onChange={setSort}
                    options={['Best match', 'Highest rated', 'Most sessions', 'Lowest price']}
                  />
                </div>
              </div>

              <div className="grid" style={{ gridTemplateColumns: 'repeat(2, 1fr)', gap: 20 }}>
                {TUTORS.map((t) => (
                  <TutorCard key={t.id} tutor={t} />
                ))}
              </div>

              <div className="flex justify-center mt-12 gap-1.5 flex-wrap">
                {[1, 2, 3, 4, 5, '…', 12].map((p, i) => (
                  <button key={i} type="button" className="font-semibold"
                    style={{
                      width: 40, height: 40, borderRadius: 10, fontSize: 14,
                      background: p === 1 ? 'var(--navy)' : '#fff',
                      color: p === 1 ? '#fff' : 'var(--ink)',
                      border: p === 1 ? 'none' : '1px solid var(--line)',
                    }}>{p}</button>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* How it works */}
      <section className="lc-section" style={{ background: 'var(--bg-cream)' }}>
        <div className="lc-container">
          <div className="text-center mb-12">
            <span className="lc-eyebrow">How it works</span>
            <h2 className="mt-3.5">From first hello to first lesson — in 4 minutes.</h2>
          </div>
          <div className="grid" style={{ gridTemplateColumns: 'repeat(4, 1fr)', gap: 24 }}>
            {[
              { n: '01', icon: '🔍', title: 'Search & filter',     desc: 'Browse by subject, language, country, or price. Read real reviews.' },
              { n: '02', icon: '📅', title: 'Book a free 15-min',  desc: 'Meet your tutor live before committing. No payment up front.' },
              { n: '03', icon: '🎙', title: 'Voice or video',      desc: 'Sessions over Lincoln voice, video chat, or in-person where available.' },
              { n: '04', icon: '🏅', title: 'Earn certificates',   desc: 'Tutor-issued certificates show up alongside your Lincoln credentials.' },
            ].map((s) => (
              <div key={s.n} className="bg-white text-center"
                style={{ padding: 24, borderRadius: 16, border: '1px solid var(--line)' }}>
                <div className="mx-auto flex items-center justify-center"
                  style={{ width: 56, height: 56, borderRadius: 14, background: 'var(--yellow)', fontSize: 26, marginBottom: 16 }}>{s.icon}</div>
                <div className="font-bold tracking-wider" style={{ fontSize: 11, color: 'var(--blue)' }}>STEP {s.n}</div>
                <h4 className="mt-1" style={{ fontSize: 18 }}>{s.title}</h4>
                <p className="mt-2 leading-relaxed" style={{ fontSize: 13, color: 'var(--muted)' }}>{s.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Become a tutor CTA */}
      <section className="lc-section on-navy" style={{ background: 'var(--navy)' }}>
        <div className="lc-container">
          <div className="grid items-center" style={{ gridTemplateColumns: '1fr auto', gap: 48 }}>
            <div>
              <span className="lc-eyebrow on-dark">Are you a tutor?</span>
              <h2 className="text-white mt-3.5" style={{ fontSize: 48 }}>
                Teach with Lincoln. Reach learners in 10 countries.
              </h2>
              <p className="mt-4" style={{ fontSize: 17, color: 'rgba(255,255,255,0.7)', maxWidth: 580 }}>
                Set your own hours and rates. Get matched with students who need exactly what you teach. Lincoln handles scheduling, payments, and certifications.
              </p>
            </div>
            <div className="flex flex-col gap-3">
              <Link to="/providers" className="lc-btn yellow lg">Apply to teach →</Link>
              <a href="#" className="lc-btn ghost-light lg">Read tutor guide</a>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}

function TutorCard({ tutor }) {
  return (
    <article className="lc-card overflow-hidden flex">
      {/* Avatar column */}
      <div className="relative flex-shrink-0" style={{ width: 140, background: tutor.color }}>
        <ImageSlot id={`tutor-${tutor.id}`} style={{ position: 'absolute', inset: 0 }} shape="rect" src={tutor.photo} placeholder="" />
        <div className="absolute"
          style={{ top: 8, left: 8, background: 'rgba(255,255,255,0.95)', color: 'var(--navy)', padding: '3px 8px', borderRadius: 4, fontSize: 9, fontWeight: 700 }}>
          ✓ VERIFIED
        </div>
      </div>
      <div className="flex flex-col flex-1 min-w-0" style={{ padding: 18 }}>
        <div className="flex items-start justify-between gap-2">
          <div className="min-w-0">
            <h4 className="leading-tight" style={{ fontSize: 18 }}>{tutor.name}</h4>
            <div className="mt-0.5" style={{ fontSize: 12, color: 'var(--muted)' }}>{tutor.country}</div>
          </div>
          <span className="font-bold flex-shrink-0" style={{ fontSize: 11, color: 'var(--yellow-2)' }}>
            ★ {tutor.rating}
          </span>
        </div>
        <div className="font-semibold mt-2" style={{ fontSize: 13, color: 'var(--blue)' }}>{tutor.subject}</div>
        <div className="flex flex-wrap gap-1 mt-2">
          {tutor.langs.map((l) => (
            <span key={l} className="rounded-full font-semibold"
              style={{ fontSize: 10, padding: '2px 7px', background: 'var(--bg-soft)', color: 'var(--ink-2)' }}>{l}</span>
          ))}
        </div>
        <div className="flex items-center justify-between mt-auto pt-3" style={{ borderTop: '1px solid var(--line)' }}>
          <div>
            <div className="font-bold font-serif" style={{ fontSize: 18, color: 'var(--ink)' }}>{tutor.rate}</div>
            <div style={{ fontSize: 11, color: 'var(--muted)' }}>{tutor.sessions} sessions</div>
          </div>
          <button type="button" className="lc-btn primary sm">Book</button>
        </div>
      </div>
    </article>
  );
}
